import type { SessionState } from "@/stores/slices/chat-slice"

/**
 * Machine-readable code for the session-error `Chat.Error` card.
 *
 * Durable failed turns stamp `error_code` on `streamingAnswer[1]`, but Explorer
 * drops an empty streaming bubble when `chatState.error` is set (#2098) and
 * renders `<Chat.Error error={chatState.error}>` instead. Legacy WS error
 * frames never put a code on the bubble. `SessionState.errorCode` is the
 * dedicated field; fall back to the still-held streaming answer so a producer
 * that only stamped the bubble still reaches the renderer.
 *
 * Do not match on `error` text. `fair_use_deep_unavailable` is a sibling code
 * and must not be rewritten to a hard block here.
 */
export function getSessionErrorCode(
  state: Pick<SessionState, "error" | "errorCode" | "streamingAnswer">
): string | undefined {
  if (!state.error) return undefined
  return state.errorCode ?? state.streamingAnswer?.[1]?.error_code
}
